import * as React from 'react';
import { components } from 'react-select';
import { QuestionTypesMap } from '@nexxt/common/questionTypes';
import { QTYPES } from '@nexxt/common/types';

const Option: React.SFC<any> = (props) => {
    const { data } = props;
    const image = QuestionTypesMap[props.data.type]
        ? QuestionTypesMap[props.data.type].image
        : QuestionTypesMap[QTYPES.SINGLE_CHOICE].image;

    return (
        <components.Option {...props} {...props.innerProps}>
            <span className="img-box">
                <img src={image} />
            </span>
            <span className="badge badge--blue">
                {data.label || data.title}
            </span>
            <span>{data.greetingText}</span>
        </components.Option>
    );
};
export default Option;

export const OptionWithoutCreateTag: React.SFC<any> = (props) => {
    if (props.data.__isNew__) {
        return (
            <components.Option {...props} {...props.innerProps}>
                Search for &quot;{props.data.value}&quot;
            </components.Option>
        );
    }
    return (
        <components.Option {...props} {...props.innerProps}>
            {props.children}
        </components.Option>
    );
};

const renderNestedOption = (props, label, nestedOptions, level) => {
    const { cx, getStyles, innerProps, selectOption } = props;
    // Will be applied to nested optgroup headers
    const nestedLabelClassName = cx({ option: true }, 'nested-optgroup-label');
    return (
        <div
            className="nested-optgroup"
            style={{ textIndent: `${level * 10}px` }}
        >
            <div
                className={nestedLabelClassName}
                style={{ ...getStyles('groupHeading', props) }}
            >
                {label}
            </div>
            {nestedOptions.map((nestedOption) => {
                if (nestedOption.options) {
                    return renderNestedOption(
                        props,
                        nestedOption.label,
                        nestedOption.options,
                        nestedOption.level
                    );
                }

                const nestedInnerProps = innerProps;
                nestedInnerProps.onClick = () => selectOption(nestedOption);
                return (
                    <div
                        className="nested-optgroup-option"
                        style={{ textIndent: `${level * 10 + 10}px` }}
                        key={nestedOption.value}
                    >
                        <components.Option
                            {...props}
                            innerProps={nestedInnerProps}
                        >
                            {nestedOption.label}
                        </components.Option>
                    </div>
                );
            })}
        </div>
    );
};

export const NestedOption = (props) => {
    const { children, data } = props;
    const nestedOptions = data.options;
    if (nestedOptions) {
        const { label, level } = data;
        return renderNestedOption(props, label, nestedOptions, level);
    }

    return <components.Option {...props}>{children}</components.Option>;
};
